module.exports = __webpack_public_path__ + "media/packs/images/small-upload-6caa91f2e04ea9dd557a5a560e9d057e.svg";